import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class JourneyJobsService {
  private readonly midMonthUrl = `${environment.welbyEndpoint}/api/v1/jobs/mid-month-journey-update`;
  private readonly monthlyTasksUrl = `${environment.welbyEndpoint}/api/v1/jobs/monthly-journey-tasks`;

  constructor(private http: HttpClient) {}

  triggerMidMonthUpdate(patientId: string): void {
    this.http.post(this.midMonthUrl, { patientId }).subscribe({
      next: () => {},
      error: (err) => console.error('[JourneyJobs] mid-month-journey-update failed', err),
    });
  }

  triggerMonthlyJourneyTasks(patientId: string): void {
    this.http.post(this.monthlyTasksUrl, { patientId }).subscribe({
      next: () => {},
      error: (err) => console.error('[JourneyJobs] monthly-journey-tasks failed', err),
    });
  }
}
